/*
 * Mobile-only email report form (spam/phishing/suspicious).
 * Used in MobileReportScreen (standalone) or below AccessDeniedScreen (with top border).
 */

import React from "react";
import i18n from "../../../i18n/i18n.js";

export default function MobileEmailReport({
  reportType,
  setReportType,
  reportAdditionalInfo,
  setReportAdditionalInfo,
  reportingEmail,
  onReport,
  standalone = false,
}) {
  const containerClass = standalone
    ? "flex-1 flex flex-col gap-4"
    : "flex-1 flex flex-col gap-4 border-t border-gray-200 pt-4 mt-4";

  return (
    <div className={containerClass}>
      <h3 className="text-base font-semibold text-gray-900">
        {i18n.t("messages.reportSuspiciousEmail")}
      </h3>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {i18n.t("messages.reportType")}
        </label>
        <div className="space-y-2">
          <label className="flex items-center">
            <input
              type="radio"
              name="reportType"
              value="spam"
              checked={reportType === "spam"}
              onChange={(e) => setReportType(e.target.value)}
              className="mr-2 accent-[#0C75D1]"
            />
            <span className="text-sm text-gray-700">{i18n.t("commands.reportTypeSpam")}</span>
          </label>
          <label className="flex items-center">
            <input
              type="radio"
              name="reportType"
              value="phishing"
              checked={reportType === "phishing"}
              onChange={(e) => setReportType(e.target.value)}
              className="mr-2 accent-[#0C75D1]"
            />
            <span className="text-sm text-gray-700">{i18n.t("commands.reportTypePhishing")}</span>
          </label>
          <label className="flex items-center">
            <input
              type="radio"
              name="reportType"
              value="suspicious"
              checked={reportType === "suspicious"}
              onChange={(e) => setReportType(e.target.value)}
              className="mr-2 accent-[#0C75D1]"
            />
            <span className="text-sm text-gray-700">{i18n.t("commands.reportTypeSuspicious")}</span>
          </label>
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {i18n.t("messages.additionalInformation")}
        </label>
        <textarea
          value={reportAdditionalInfo}
          onChange={(e) => setReportAdditionalInfo(e.target.value)}
          rows={4}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
          placeholder={i18n.t("messages.additionalInfoPlaceholder")}
        />
      </div>

      <button
        onClick={onReport}
        disabled={!reportType || reportingEmail}
        className="w-full bg-[#46A2F2] text-white px-4 py-2 rounded-md hover:bg-[#0C75D1] focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {reportingEmail ? i18n.t("messages.reporting") : i18n.t("messages.reportEmail")}
      </button>
    </div>
  );
}
